import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { BookOpenCheck } from "lucide-react";

export default function SeoText() {
  const { t } = useLang();
  const blocks = [1, 2, 3].map((n) => ({ h: t(`seo.h${n}`), p: t(`seo.p${n}`) }));
  return (
    <section id="guida" className="py-20 lg:py-28" data-testid="seo-guide-section">
      <div className="max-w-4xl mx-auto px-5 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}>
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#00AEEF]">{t("seo.kicker")}</p>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#003087] mt-3">{t("seo.title")}</h2>
        </motion.div>
        <div className="mt-12 space-y-10">
          {blocks.map((b, i) => (
            <motion.article key={i}
              initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.6, delay: i * 0.1 }}
              className="flex gap-5" data-testid={`seo-block-${i + 1}`}>
              <span className="w-10 h-10 rounded-xl bg-[#E6F6FD] border border-[#00AEEF]/25 flex items-center justify-center shrink-0 mt-1">
                <BookOpenCheck size={17} className="text-[#00AEEF]" />
              </span>
              <div>
                <h3 className="text-lg sm:text-xl font-bold text-[#003087]">{b.h}</h3>
                <p className="mt-3 text-sm sm:text-base text-[#1A1A1A] leading-relaxed">{b.p}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
